///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const SettingsIcon = ({
  height,
  title = messages.settings.defaultMessage,
  width
}) => (
  <svg
    aria-labelledby="settings-icon"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="settings-icon">{title}</title>
    <defs>
      <path
        d="M16.192 10.817c.033-.267.058-.534.058-.817 0-.283-.025-.55-.058-.817l1.758-1.375a.42.42 0 00.1-.533l-1.667-2.883c-.1-.184-.325-.25-.508-.184l-2.075.834a6.088 6.088 0 00-1.408-.817l-.317-2.208a.406.406 0 00-.408-.35H8.333a.406.406 0 00-.408.35l-.317 2.208a6.402 6.402 0 00-1.408.817l-2.075-.834a.406.406 0 00-.508.184L1.95 7.275a.41.41 0 00.1.533l1.758 1.375A6.609 6.609 0 003.75 10c0 .275.025.55.058.817L2.05 12.192a.42.42 0 00-.1.533l1.667 2.883c.1.184.325.25.508.184l2.075-.834c.433.334.9.609 1.408.817l.317 2.208c.025.2.2.35.408.35h3.334c.208 0 .383-.15.408-.35l.317-2.208a6.402 6.402 0 001.408-.817l2.075.834c.192.075.408 0 .508-.184l1.667-2.883a.42.42 0 00-.1-.533l-1.758-1.375zM10 12.917A2.92 2.92 0 017.083 10 2.92 2.92 0 0110 7.083 2.92 2.92 0 0112.917 10 2.92 2.92 0 0110 12.917z"
        id="settings-icon-path"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <mask id="settings-icon-mask" fill="#fff">
        <use xlinkHref="#settings-icon-path" />
      </mask>
      <use fill="#000" xlinkHref="#settings-icon-path" />
      <g mask="url(#settings-icon-mask)" fill="#FFF">
        <path d="M0 0h20v20H0z" />
      </g>
    </g>
  </svg>
);

export default SettingsIcon;
